webpackJsonp([262374124431890],{

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  text-transform: uppercase;\n  font-weight: bold;\n  text-align: center;\n  color: ', ';\n  position: relative;\n  padding-bottom: 1rem;\n  margin-bottom: 4rem;\n\n  &:after {\n    content: \'\';\n    height: 1px;\n    width: 50px;\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    margin-left: -25px;\n    background: ', ';\n  }\n'], ['\n  font-size: ', ';\n  text-transform: uppercase;\n  font-weight: bold;\n  text-align: center;\n  color: ', ';\n  position: relative;\n  padding-bottom: 1rem;\n  margin-bottom: 4rem;\n\n  &:after {\n    content: \'\';\n    height: 1px;\n    width: 50px;\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    margin-left: -25px;\n    background: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Title = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.fontSmall;
	}, function (props) {
	  return props.theme.dark;
	}, function (props) {
	  return props.theme.ultraLight;
	});
	
	var SectionTitle = function SectionTitle(props) {
	  return _react2.default.createElement(
	    Title,
	    null,
	    props.children
	  );
	};
	
	exports.default = SectionTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.postQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  grid-column: 2;\n  box-shadow: 0 4px 120px rgba(0, 0, 0, 0.1);\n  border-radius: 1rem;\n  padding: 2rem 4rem;\n  background-color: ', ';\n  z-index: 9000;\n  margin-top: -3rem;\n  @media ', ' {\n    padding: 3rem 3rem;\n  }\n  @media ', ' {\n    padding: 2rem 1.5rem;\n  }\n'], ['\n  grid-column: 2;\n  box-shadow: 0 4px 120px rgba(0, 0, 0, 0.1);\n  border-radius: 1rem;\n  padding: 2rem 4rem;\n  background-color: ', ';\n  z-index: 9000;\n  margin-top: -3rem;\n  @media ', ' {\n    padding: 3rem 3rem;\n  }\n  @media ', ' {\n    padding: 2rem 1.5rem;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  text-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\n  margin-bottom: 0.75rem;\n'], ['\n  position: relative;\n  text-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\n  margin-bottom: 0.75rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _kebabCase = __webpack_require__(100);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _Wrapper = __webpack_require__(41);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _Header = __webpack_require__(61);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SectionTitle = __webpack_require__(113);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _media = __webpack_require__(18);
	
	var _SiteConfig = __webpack_require__(17);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Content = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.bg;
	}, _media.media.tablet, _media.media.phone);
	
	var Title = _styledComponents2.default.h3(_templateObject2);
	
	var Category = function Category(props) {
	  var group = props.data.allMarkdownRemark.group;
	
	
	  return _react2.default.createElement(
	    _Wrapper2.default,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Categories | ' + _SiteConfig2.default.siteTitle }),
	    _react2.default.createElement(
	      _Header2.default,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        _SiteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(
	        _SectionTitle2.default,
	        null,
	        'Categories'
	      ),
	      group.map(function (category) {
	        return _react2.default.createElement(
	          Title,
	          { key: (0, _kebabCase2.default)(category.fieldValue) },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/categories/' + (0, _kebabCase2.default)(category.fieldValue) },
	            category.fieldValue
	          ),
	          ' (',
	          category.totalCount,
	          ')'
	        );
	      })
	    )
	  );
	};
	
	exports.default = Category;
	
	/* eslint no-undef: off */
	
	var postQuery = exports.postQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-categories-js-5808381e4be7fccfbe4b.js